import { render, staticRenderFns } from "./general-layout.vue?vue&type=template&id=528796af&scoped=true&"
import script from "./general-layout.vue?vue&type=script&lang=js&"
export * from "./general-layout.vue?vue&type=script&lang=js&"
import style0 from "./general-layout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./general-layout.vue?vue&type=style&index=1&id=528796af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528796af",
  null
  
)

export default component.exports